export const totalNetIncomeAtAge = (forecast, age) => {
  const dataPointAtAge = forecast.find((datapoint) => datapoint.age === age)

  return dataPointAtAge?.net_monthly_income || 0
}

export const totalNetExpenseAtAge = (forecast, age) => {
  const dataPointAtAge = forecast.find((datapoint) => datapoint.age === age)

  return dataPointAtAge?.total_monthly_expenses || 0
}

export const totalLiabilityRepaymentsAtAge = (forecast, age) => {
  const dataPointAtAge = forecast.find((datapoint) => datapoint.age === age)

  return dataPointAtAge?.total_liability_repayments || 0
}

export const totalAdditionalIncomeFromInvestmentsAtAge = (forecast, age) => {
  const dataPointAtAge = forecast.find((datapoint) => datapoint.age === age)

  return dataPointAtAge?.total_additional_gross_monthly_income_from_assets || 0
}

export const totalMonthlyCashflowExpensesAtAge = (forecast, age) => {
  const dataPointAtAge = forecast.find((datapoint) => datapoint.age === age)

  return (dataPointAtAge?.expense_breakdown?.annual_cashflow_expense_nominal / 12) || 0
}

export const totalMonthlyCashflowIncomeAtAge = (forecast, age) => {
  const dataPointAtAge = forecast.find((datapoint) => datapoint.age === age)

  return (dataPointAtAge?.net_income_breakdown?.cashflow_income_nominal / 12) || 0
}
